module.exports = __webpack_public_path__ + "static/img/404.a57b6f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/404.png
// module id = JT0z
// module chunks = 5